import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { get } from '../../../core/client';
// import { getLocalStorageItem } from '../../../core/utility';
import { ILocalizationWords } from './model';

export const getLocalizationWords: any = createAsyncThunk('localization/getLocalizationWords', async () => {
    // const language = getLocalStorageItem('SelectedLanguage');
    const URL = `localization/list?Version=0&Platform=WEB&Culture=${'tr-TR'}`;
    // const URL = `localization/list?Version=0&Platform=WEB&Culture=${language.culture}`;

    const localizationWords = await get<any>(URL);
    return localizationWords;
});

const localizationSlice = createSlice({
    name: 'localization',
    initialState: {
        loading: true,
        words: {},
        languageInitialData: [
            { culture: 'tr-TR', name: 'Türkçe', cultureName: 'TR' },
            { culture: 'en-US', name: 'English', cultureName: 'EN' },
        ],
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getLocalizationWords.fulfilled, (state, action: PayloadAction<ILocalizationWords>) => {
            if (action.payload.isSuccessful) {
                const words = {};
                for (let i = 0; i < action.payload.result.list.length; i++) {
                    const element: any = action.payload.result.list[i];
                    words[element.key] = element.value;
                }
                state.words = words;
            }
            state.loading = false;
        });
    },
});

export default localizationSlice.reducer;
